export const en = {
    'auth-as': 'Authorized as',
    'bd-config': 'Database configuration',
    'beta-number': 'Beta version number',
    'disable-captcha': 'Disable captcha',
    'dump-vars': 'Enable dump_vars',
    'fake-auth': 'Fake authorization',
    features: 'Features list',
    role: 'Role',
    shard: 'Shard'
};
